import { Modal, Button } from "@mui/material";
import { CompleteTheLotDialogStyles } from "./LotInfoBarStyles";
import { SpringUpDown } from "components/Animations/SpringUpDown";
import type { LotInfoType } from "types/types";
import Spinner from "components/SimpleComponents/Spinner/Spinner";
import { useIsDarkMode } from "store/atoms";

type CompleteTheLotModalProps = {
  isCompletingTheLot: boolean;
  isDialogOpen: boolean;
  lotInfo: LotInfoType;
  handleCloseCompleteTheLotDialog: any;
  handleCompleteTheLot: any;
};

const CompleteTheLotModal = ({
  isCompletingTheLot,
  isDialogOpen,
  lotInfo,
  handleCloseCompleteTheLotDialog,
  handleCompleteTheLot,
}: CompleteTheLotModalProps) => {
  const [isDarkMode] = useIsDarkMode();
  return (
    <Modal
      open={isDialogOpen}
      closeAfterTransition={true}
      onClose={handleCloseCompleteTheLotDialog}
    >
      <SpringUpDown
        in={Boolean(isDialogOpen)}
        style={{
          width: "fit-content",
        }}
        isAnimationEnabled={true}
      >
        <CompleteTheLotDialogStyles $isDarkMode={isDarkMode}>
          <div className="content">
            <div className="confirmText">
              <p className="title">
                Complete lot #{lotInfo?.lotNumber} and begin lot #
                {lotInfo.nextLotNumber}?
              </p>
              <p className="subtext" style={{ fontWeight: "bold" }}>
                Warning: this can{`'`}t be undone.
              </p>
              <p className="subtext">
                Completing the lot will cause the database to stop tracking
                output of the current lot, and start tracking output of the next
                lot. The output line and Forecasted Lot Completion will reset to
                reflect the new lot.
              </p>
            </div>
            <div className="actions">
              <Button
                variant="outlined"
                onClick={handleCloseCompleteTheLotDialog}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="btnComplete"
                disabled={isCompletingTheLot}
                onClick={handleCompleteTheLot}
              >
                {isCompletingTheLot ? (
                  <div style={{ display: "flex" }}>
                    <span style={{ marginRight: 8, color: "white" }}>
                      Working...
                    </span>
                    <Spinner width={16} />
                  </div>
                ) : (
                  "Complete Lot"
                )}
              </Button>
            </div>
          </div>
        </CompleteTheLotDialogStyles>
      </SpringUpDown>
    </Modal>
  );
};

export default CompleteTheLotModal;
